import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturedGames from './components/FeaturedGames';
import GameCategories from './components/GameCategories';
import LatestArticles from './components/LatestArticles';
import FaqSection from './components/FaqSection';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '18网页游戏',
  url: 'https://www.18webgame.com',
  description: '精选热门网页游戏大全，无需下载即点即玩。覆盖角色扮演、策略、射击、休闲等多种类型。',
  inLanguage: 'zh-CN',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://www.18webgame.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: '18网页游戏需要下载安装吗？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '不需要！18网页游戏平台上的所有游戏都支持即点即玩，只需要浏览器就能畅快游戏，无需等待下载和安装。',
      },
    },
    {
      '@type': 'Question',
      name: '网页游戏是免费的吗？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '平台上的大部分网页游戏都采用免费游玩模式。你可以免费体验核心内容，部分游戏提供可选的内购道具或加速服务。',
      },
    },
    {
      '@type': 'Question',
      name: '网页游戏画质怎么样？能和客户端游戏比吗？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '随着HTML5和WebGL技术的飞速发展，现代网页游戏的画质已经大幅提升。许多精品网页游戏的画面表现已经非常接近甚至达到了一些客户端游戏的水准。',
      },
    },
    {
      '@type': 'Question',
      name: '我的电脑配置不高，能玩网页游戏吗？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '相比需要安装的客户端游戏，网页游戏对硬件配置的要求低很多。只要能流畅浏览网页，就基本能畅玩平台上的绝大多数游戏。',
      },
    },
    {
      '@type': 'Question',
      name: '18网页游戏支持手机游玩吗？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '我们平台持续收录支持移动端适配的优质网页游戏。你可以通过手机浏览器直接访问并游玩，无需下载App。',
      },
    },
    {
      '@type': 'Question',
      name: '平台上游戏安全吗？会不会有病毒？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '18网页游戏平台严格筛选所有上架游戏，确保每款游戏都经过安全审核。网页游戏在浏览器沙盒环境中运行，不会对设备造成安全威胁。',
      },
    },
  ],
};

export default function Home() {
  const { pathname } = useLocation();

  useEffect(() => {
    document.title = '18 网页游戏 - 精选热门网页游戏大全';
    window.scrollTo({ top: 0, behavior: 'instant' as const });
  }, [pathname]);

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <GameCategories />
        <FeaturedGames />
        <LatestArticles />
        <FaqSection />
      </main>
      <Footer />
    </>
  );
}